import React, { useCallback, useEffect, useMemo, useState } from 'react';
import {
  Button,
  Checkbox,
  Col,
  Divider,
  Form,
  Input,
  notification,
  Row,
  Select,
} from 'antd';
import { useGlobalState } from './GlobalState';
import ProductAddOn from './ProductAddOn';
import axios from 'axios';
import { useHistory } from 'react-router';
import { exotic_fishery } from '../../common/Utils';
import infoIcon from '../assets/images/information.svg';
import UserBookingNavButtons from './UserBookingNavButtons';
import SvgUserBox from '../assets/images/UserBox';
import { costString, getSummaryCosts } from '../../../utils/cost';
import {
  useGetMemberSettingsQuery,
  useGetSeasonTicketValidationQuery,
} from '../../admin/components/settings/settingsSlice';
import { sendWidgetMessage } from '../../../utils/widgetUtils';
import {
  PRIVACY_POLICY_URL,
  TERMS_AND_CONDITIONS_URL,
} from '../../../AppConstants';
import Summary from '../../admin/components/lake_manager/components/Summary';
import {
  useGetAddOnsQuery,
  useGetCustomPropertiesQuery,
} from '../../admin/components/bookings/bookingSlice';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import countryCodes from '../assets/data/iso3166_country_codes';
import { useGetDynamicBookingTextQuery } from '../../user_profile/userProfileSlice';

const hawkhurst_id = process.env.REACT_APP_FISHERY_HAWKHURST_ID;
const sandHurst_id = process.env.REACT_APP_FISHERY_SANDHURST_ID;
const lane_fishery_id = process.env.REACT_APP_FISHERY_LANE_ID;
const tregonethaLake = process.env.REACT_APP_FISHERY_TREGONETHA_LAKE_ID;
const alderLakeId = '1760775b-5ac7-4273-a757-5eb46f676539';

const comptonsLake = 11833;
export default function Step3({ fishery_id }) {
  const [current, setCurrent] = useGlobalState('current');
  const [customPropertyDetails, setCustomPropertyDetails] = useGlobalState(
    'customPropertiesDetails'
  );
  const [userSelectedAnglers] = useGlobalState('userSelectedAnglers');
  const [estimatedPricing] = useGlobalState('estimatedPricing');
  const [userBookingData, setUserBookingData] =
    useGlobalState('userBookingData');
  const [, setLoading] = useState(true);
  const [accommodation] = useGlobalState('accommodation');
  const [userInfo, setUserInfo] = useGlobalState('userInfo');
  const [maxRod] = useGlobalState('maxRod');
  const [lakeExclusive] = useGlobalState('lakeExclusive');
  const [lakeType] = useGlobalState('lakeType');
  const [lakeDetails] = useGlobalState('lakeDetails');
  const [bookingType] = useGlobalState('bookingType');
  const [isInsideWidget] = useGlobalState('isInsideWidget');

  const [userSelectedLakeId] = useGlobalState('userSelectedLakeId');
  const [cartItems, setCartItems] = useGlobalState('productItem');
  const [disableNext, setDisableNext] = useState(true);
  const [fisheryInfo] = useGlobalState('fisheryInfo');
  const [userSelectedPakage] = useGlobalState('userSelectedPakage');
  const [registerationNumber, setRegistrationNumber] = useState('');
  const { data: memberSetting } = useGetMemberSettingsQuery(fishery_id);
  const { data: DynamicText } = useGetDynamicBookingTextQuery(fishery_id);
  const { data: ProductsData } = useGetAddOnsQuery(
    {
      fisheryId: fishery_id,
      packageId: userSelectedPakage
        ? lakeDetails?.custom_slot_days[userSelectedPakage - 1]?.id
        : null,
      lakeId: userSelectedLakeId,
    },
    {
      skip: !fishery_id,
    }
  );
  const { data: customProperties } = useGetCustomPropertiesQuery(
    {
      fisheryId: fishery_id,
      bookingType: lakeExclusive ? 'lake_exclusive' : bookingType,
      lakeId: userSelectedLakeId,
    },
    {
      skip: !fishery_id,
    }
  );
  const { data: seasonTicketHolder } = useGetSeasonTicketValidationQuery({
    lake_id: lakeDetails.lake_id,
    email: userInfo.email,
  });
  const isSeasonTicketHolder = seasonTicketHolder?.season_ticket;
  const is_exotic_arapaima_lake =
    userSelectedLakeId === 'a4688274-3f67-40a5-be8d-a8dc51c053b3';
  const is_exotic_fishery = fishery_id === exotic_fishery;
  const history = useHistory();

  const countryOptions = useMemo(() => {
    return (
      countryCodes
        // Move United Kingdom to the start
        .sort(({ Code: x }, { Code: y }) =>
          x === 'GB' ? -1 : y === 'GB' ? 1 : 0
        )
        .map(({ Code, Name }) => ({
          label: Name,
          value: Code,
        }))
    );
  }, []);
  const isNotDuplicated = (anglerDetailsList) => {
    const emailSet = new Set();
    const nameSet = new Set();

    for (const userDetail of anglerDetailsList) {
      const { first_name, last_name, email } = userDetail;

      // Check for duplicate email
      if (email !== '' && emailSet.has(email.toLowerCase())) {
        return false; // Duplicate email found
      }
      emailSet.add(email.toLowerCase());

      // Check for duplicate name (first name + last name)
      const fullName = `${first_name.toLowerCase()} ${last_name.toLowerCase()}`;
      if (fullName.trim() !== '' && nameSet.has(fullName)) {
        return false; // Duplicate name found
      }
      nameSet.add(fullName);
    }

    return true; // No duplicates found
  };

  const {
    total: estimatedTotal,
    advance: estimatedDeposit,
    balance: estimatedBalance,
    isDiscounted: isEstimateDiscounted,
    discountedTotal: estimatedDiscountedTotal,
  } = getSummaryCosts(lakeExclusive, is_exotic_fishery, estimatedPricing);

  const [form] = Form.useForm();
  const sandHurstTicketLake =
    fishery_id === sandHurst_id &&
    lakeType.toLowerCase() === 'ticket' &&
    !lakeExclusive;
  const showErrorNotification = (message) =>
    notification.error({
      message: <div className='gSemiBold'>There was an issue!</div>,
      style: { border: '1px #D34545 solid' },
      placement: window?.innerWidth <= 500 ? 'bottom' : 'topRight',
      className: 'gRegular br10',
      description: message,
    });

  const handleGetAnglerDetailsError = useCallback(
    (err) => {
      if (err.response) {
        if (err.response.status === 500) {
          showErrorNotification(
            'Server Response failed. Please try again later'
          );
        } else if (
          err.response.status === 422 &&
          err.response.data.detail === 'Signature has expired'
        ) {
          showErrorNotification('Please login to continue');
          if (isInsideWidget) {
            sendWidgetMessage({ type: 'widgetCollapse' });
          } else {
            history.push(`/fishery/${fishery_id}`);
          }
        } else if (err.response.status === 422) {
          showErrorNotification(
            "OOPS! Server didn't like the request. If this persists please contact support team"
          );
        } else if (err.response.status === 423) {
          showErrorNotification(
            'Sorry ! this booking slot has been booked by another user, Try different booking!'
          );
        }
      }
    },
    [fishery_id, history]
  );

  const copyAsAbove = (index) => {
    if (memberSetting?.enforce_unique_angler) {
      notification.error({
        message: <div className='gSemiBold'>There was an issue!</div>,
        style: { border: '1px #D34545 solid' },
        placement: window?.innerWidth <= 500 ? 'bottom' : 'topRight',
        className: 'gRegular br10',
        description:
          'This venue requires you to enter unique details for each angler in your booking. Please edit your details to proceed.',
      });
      return;
    }

    if (isSeasonTicketHolder) {
      notification.error({
        message: <div className='gSemiBold'>There was an issue!</div>,
        style: { border: '1px #D34545 solid' },
        placement: window?.innerWidth <= 500 ? 'bottom' : 'topRight',
        className: 'gRegular br10',
        description:
          "As a season ticket holder, you can't use your details for multiple anglers in your party. Please enter different details in order to proceed.",
      });
      return;
    }
    if (
      !memberSetting?.is_duplicate_permitted &&
      lakeDetails?.access_type === 'Member only'
    ) {
      notification.error({
        message: <div className='gSemiBold'>There was an issue!</div>,
        style: { border: '1px #D34545 solid' },
        placement: window?.innerWidth <= 500 ? 'bottom' : 'topRight',
        className: 'gRegular br10',
        description:
          'This member lake requires you to enter different details for every angler. Please ensure all anglers are registered members.',
      });
      return;
    }
    const value = form.getFieldsValue(true);
    value.angler_details[index].first_name =
      value.angler_details[index - 1].first_name;
    value.angler_details[index].last_name =
      value.angler_details[index - 1].last_name;
    value.angler_details[index].email = value.angler_details[index - 1].email;
    value.angler_details[index].concession =
      value.angler_details[index - 1].concession;
    value.angler_details[index].num_rod =
      value.angler_details[index - 1].num_rod;
    value.angler_details[index].phone_number =
      value.angler_details[index - 1].phone_number;
    form.setFieldsValue({
      angler_details: value.angler_details,
    });
    updatePricing();
  };
  const copyForAll = () => {
    if (memberSetting?.enforce_unique_angler) {
      notification.error({
        message: <div className='gSemiBold'>There was an issue!</div>,
        style: { border: '1px #D34545 solid' },
        placement: window?.innerWidth <= 500 ? 'bottom' : 'topRight',
        className: 'gRegular br10',
        description:
          'This venue requires you to enter unique details for each angler in your booking. Please edit your details to proceed.',
      });
      return;
    }

    if (isSeasonTicketHolder) {
      notification.error({
        message: <div className='gSemiBold'>There was an issue!</div>,
        style: { border: '1px #D34545 solid' },
        placement: window?.innerWidth <= 500 ? 'bottom' : 'topRight',
        className: 'gRegular br10',
        description:
          "As a season ticket holder, you can't use your details for multiple anglers in your party. Please enter different details in order to proceed.",
      });
      return;
    }

    if (
      !memberSetting?.is_duplicate_permitted &&
      lakeDetails?.access_type === 'Member only'
    ) {
      notification.error({
        message: <div className='gSemiBold'>There was an issue!</div>,
        style: { border: '1px #D34545 solid' },
        placement: window?.innerWidth <= 500 ? 'bottom' : 'topRight',
        className: 'gRegular br10',
        description:
          'This member lake requires you to enter different details for every angler. Please ensure all anglers are registered members.',
      });
      return;
    }
    const value = form.getFieldsValue(true);
    for (let index = 1; index < value.angler_details.length; index++) {
      value.angler_details[index].first_name =
        value.angler_details[0].first_name;
      value.angler_details[index].last_name = value.angler_details[0].last_name;
      value.angler_details[index].email = value.angler_details[0].email;
      value.angler_details[index].concession =
        value.angler_details[0].concession;
      value.angler_details[index].num_rod = value.angler_details[0].num_rod;
      value.angler_details[index].phone_number =
        value.angler_details[0].phone_number;
    }
    form.setFieldsValue({
      angler_details: value.angler_details,
    });
    updatePricing();
  };

  const generateList = (maxAngler) => {
    let list = [];
    if (userSelectedLakeId === process.env.REACT_APP_ORCHID_LAKE) {
      for (let i = 2; i <= maxAngler; i++) {
        list.push(i);
      }
    } else {
      for (let i = 1; i <= maxAngler; i++) {
        list.push(i);
      }
    }

    return list;
  };

  const generateAnglerList = useCallback(
    (anglerInfo = undefined) => {
      let list = [];

      list.push({
        first_name: anglerInfo?.first_name,
        last_name: anglerInfo?.last_name,
        email: anglerInfo?.email,
        phone_number: anglerInfo?.contact,
        ...(lakeExclusive || fishery_id === exotic_fishery || accommodation
          ? {}
          : { num_rod: '' }),
        concession: false,
      });

      for (let i = 1; i <= userSelectedAnglers - 1; i++) {
        list.push({
          first_name: '',
          last_name: '',
          email: '',
          phone_number: '',
          num_rod: '',
          ...(fishery_id === exotic_fishery || accommodation
            ? {}
            : { num_rod: '' }),
          concession: false,
        });
      }
      form.setFieldsValue({
        angler_details: list,
      });
      return list;
    },
    [form, fishery_id, lakeExclusive, userSelectedAnglers]
  );

  const getAnglerDetails = useCallback(() => {
    const axios_config = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    };

    let data = [];
    axios
      .get('user', axios_config)
      .then((res) => {
        if (res.status === 200) {
          data = res.data.result;
          setUserInfo(data);
          setLoading(false);
          generateAnglerList(data);
        }
      })
      .catch(handleGetAnglerDetailsError);
  }, [generateAnglerList, handleGetAnglerDetailsError, setUserInfo]);

  const onFinish = (formData) => {
    console.log(formData);
    const validAnglerDetails = isNotDuplicated(formData?.angler_details);

    if (memberSetting?.enforce_unique_angler && !validAnglerDetails) {
      notification.error({
        message: <div className='gSemiBold'>There was an issue!</div>,
        style: { border: '1px #D34545 solid' },
        placement: window?.innerWidth <= 500 ? 'bottom' : 'topRight',
        className: 'gRegular br10',
        description:
          'This venue requires you to enter unique details for each angler in your booking. Please edit your details to proceed.',
      });
      return;
    }

    if (isSeasonTicketHolder && !validAnglerDetails) {
      notification.error({
        message: <div className='gSemiBold'>There was an issue!</div>,
        style: { border: '1px #D34545 solid' },
        placement: window?.innerWidth <= 500 ? 'bottom' : 'topRight',
        className: 'gRegular br10',
        description:
          "As a season ticket holder, you can't use your details for multiple anglers in your party. Please enter different details in order to proceed.",
      });
      return;
    }

    if (!isFormValid) {
      notification.error({
        message: <div className='gSemiBold'>There was an issue!</div>,
        style: { border: '1px #D34545 solid' },
        placement: window?.innerWidth <= 500 ? 'bottom' : 'topRight',
        className: 'gRegular br10',
        description:
          'Please fill all additional booking information in order to proceed to summary.',
      });
      return;
    }

    if (
      !memberSetting?.is_duplicate_permitted &&
      !validAnglerDetails &&
      lakeDetails?.access_type === 'Member only'
    ) {
      notification.error({
        message: <div className='gSemiBold'>There was an issue!</div>,
        style: { border: '1px #D34545 solid' },
        placement: window?.innerWidth <= 500 ? 'bottom' : 'topRight',
        className: 'gRegular br10',
        description:
          'This member lake requires you to enter different details for every angler. Please ensure all anglers are registered members.',
      });
      return;
    }

    setUserBookingData({
      ...formData,
      vehicle_registration_number: registerationNumber,
      proceedSummary: true,
    });
  };

  const onchangeFname = () => {};

  useEffect(() => {
    if (!userBookingData?.angler_details) {
      window.scrollTo(0, 0);
      // New booking: Initialise angler list with current user's details
      generateAnglerList();
      getAnglerDetails();
    } else {
      // Editing previously entered booking information
      let userAnglerDetails = userBookingData.angler_details;

      if (userAnglerDetails.length !== userSelectedAnglers) {
        // Ensure number of anglers matches userSelectedAnglers
        userAnglerDetails = userAnglerDetails.slice(0, userSelectedAnglers);
        for (let i = userAnglerDetails.length; i < userSelectedAnglers; i++) {
          userAnglerDetails.push({
            first_name: '',
            last_name: '',
            email: '',
            phone_number: '',
            ...(fishery_id === exotic_fishery || accommodation
              ? {}
              : { num_rod: '' }),
            concession: false,
          });
        }
      }
      setRegistrationNumber(userBookingData?.vehicle_registration_number);
      form.setFieldsValue({
        angler_details: userAnglerDetails,
        notes: userBookingData?.notes,
        vehicle_registration_number:
          userBookingData?.vehicle_registration_number,
      });
    }
  }, [
    form,
    fishery_id,
    generateAnglerList,
    getAnglerDetails,
    userBookingData,
    userSelectedAnglers,
  ]);

  const updatePricing = useCallback(() => {
    setUserBookingData(form.getFieldsValue(true));
  }, [form]);

  const isFormValid = customPropertyDetails.every(
    (item) => item.field_value && item.field_value.trim() !== ''
  );
  const updateButtonDisable = () => {
    const termsAndConditionsAgreed = Boolean(
      (accommodation || form?.getFieldValue('agreement')) &&
        form?.getFieldValue('agreement2')
    );
    const priceLoaded = Boolean(estimatedPricing?.amount !== 0);
    setDisableNext(!termsAndConditionsAgreed || !priceLoaded);
  };

  const termsText = (
    <p>
      By completing this booking, you agree that all anglers have read and agree
      to comply with the fishery rules and agree with the{' '}
      <a
        href='https://comptonslakes.co.uk/terms-conditions'
        target='_blank'
        rel='noopener noreferrer'
        className='gSemiBold'
      >
        terms and conditions
      </a>{' '}
      of this venue.
    </p>
  );

  return (
    <div>
      <h1 className='fs-27 gBold black'>
        Almost there! Please enter the booking details!
      </h1>

      <Form
        key={`${userInfo?.first_name}form${userInfo?.last_name}`}
        name='dynamic_anglerform_nest_item'
        form={form}
        scrollToFirstError={{
          behavior: 'smooth',
          block: 'center',
          inline: 'nearest',
        }}
        onFinish={onFinish}
        autoComplete='off'
        onFieldsChange={updateButtonDisable}
      >
        <Row id='booking-angler-info-form' justify='space-between'>
          <Form.List name='angler_details'>
            {(fields) => (
              <>
                {fields.map((field, index) => (
                  <Col
                    span={24}
                    key={`${index}form}`}
                    className='user-angler-info'
                  >
                    <Row
                      key={`${index}angler}`}
                      span={24}
                      className='h-fit user-angler-info-heading '
                      style={{ 'justify-content': 'space-between' }}
                    >
                      <span className='white gSemiBold fs-16 pd-left-10 pd-2 row-center gap-05r'>
                        <SvgUserBox className={'mg-bottom-2'} />
                        {accommodation
                          ? 'Guest Details'
                          : is_exotic_fishery && !is_exotic_arapaima_lake
                            ? 'Guest'
                            : ' Angler'}{' '}
                        {!accommodation && index + 1}{' '}
                      </span>
                      {fields.length > 1 ? (
                        index === 0 ? (
                          <div style={{ display: 'flex' }}>
                            {!isSeasonTicketHolder &&
                              !memberSetting?.enforce_unique_angler && (
                                <>
                                  <span
                                    className='white gLight'
                                    style={{
                                      display: 'flex',
                                      'align-items': 'center',
                                    }}
                                  >
                                    Same details for all:
                                  </span>
                                  <Button
                                    className=' gSemiBold br5 light-green-bg sb-white mg-left-15 h-30'
                                    type='primary'
                                    onClick={() => copyForAll(index)}
                                    style={{ border: 'none' }}
                                  >
                                    Apply
                                  </Button>
                                </>
                              )}
                          </div>
                        ) : (
                          <div style={{ display: 'flex' }}>
                            {!isSeasonTicketHolder &&
                              !memberSetting?.enforce_unique_angler && (
                                <>
                                  <span
                                    className='white gLight'
                                    style={{
                                      display: 'flex',
                                      'align-items': 'center',
                                    }}
                                  >
                                    Same details as above:
                                  </span>
                                  <Button
                                    className=' gSemiBold br5 light-green-bg sb-white mg-left-15 h-30'
                                    type='primary'
                                    onClick={() => copyAsAbove(index)}
                                    style={{ border: 'none' }}
                                  >
                                    Apply
                                  </Button>
                                </>
                              )}
                          </div>
                        )
                      ) : (
                        ''
                      )}
                    </Row>

                    <Col>
                      <Form.Item
                        {...field}
                        label='First Name'
                        className='gSemiBold sb-light-black txt-left'
                        labelCol={{
                          span: 8,
                          offset: 1,
                        }}
                        wrapperCol={{
                          span: 14,
                        }}
                        name={[field.name, 'first_name']}
                        Key='first_name'
                        onChange={(e) => onchangeFname(e)}
                        rules={[
                          { required: true, message: 'Missing first name' },
                        ]}
                      >
                        <Input
                          className='gLight mg-left-10'
                          placeholder='First Name'
                        />
                      </Form.Item>

                      <Form.Item
                        {...field}
                        label='Last Name'
                        className='gSemiBold sb-light-black txt-left'
                        labelCol={{
                          span: 8,
                          offset: 1,
                        }}
                        wrapperCol={{
                          span: 14,
                        }}
                        name={[field.name, 'last_name']}
                        Key='last_name'
                        rules={[
                          { required: true, message: 'Missing last name' },
                        ]}
                      >
                        <Input
                          className='gLight mg-left-10'
                          placeholder='Last Name'
                        />
                      </Form.Item>

                      <Form.Item
                        {...field}
                        label='E-mail'
                        name={[field.name, 'email']}
                        Key='email'
                        labelCol={{
                          span: 8,
                          offset: 1,
                        }}
                        wrapperCol={{
                          span: 14,
                        }}
                        rules={[
                          {
                            type: 'email',
                            required: true,
                            message: 'Incorrect Email',
                            validateStatus: 'success',
                          },
                        ]}
                        className='sb-anglers-email gSemiBold sb-light-black txt-left'
                      >
                        <Input
                          className='gLight mg-left-10'
                          placeholder='Email'
                        />
                      </Form.Item>
                      <Form.Item
                        {...field}
                        name={[field.name, 'phone_number']}
                        Key='phone_number'
                        labelCol={{
                          span: 8,
                          offset: 1,
                        }}
                        wrapperCol={{
                          span: 14,
                        }}
                        label={'Contact Number'}
                        className='gSemiBold fs-16'
                        rules={[
                          index === 0
                            ? {
                                required: true,
                                message: 'Missing contact number',
                              }
                            : '',
                        ]}
                      >
                        <Input
                          type='number'
                          className='gLight mg-left-10'
                          placeholder='Contact number'
                        />
                      </Form.Item>
                      {lakeExclusive ||
                      fishery_id === exotic_fishery ||
                      accommodation ? (
                        ''
                      ) : (
                        <>
                          <Form.Item
                            {...field}
                            label='No. Of Rods'
                            name={[field.name, 'num_rod']}
                            labelCol={{
                              span: 8,
                              offset: 1,
                            }}
                            wrapperCol={{
                              span: 14,
                            }}
                            Key='num_rod'
                            rules={[
                              {
                                required: true,
                                message:
                                  'Please select the number of rods for all anglers',
                              },
                            ]}
                            className='sb-anglers-rod_select gSemiBold sb-light-black txt-left'
                          >
                            <Select
                              className='mg-left-10'
                              onChange={() => updatePricing()}
                            >
                              {generateList(maxRod).map((id) => {
                                return (
                                  <Select.Option
                                    className='gSemiBold'
                                    value={id}
                                  >
                                    {id}
                                  </Select.Option>
                                );
                              })}
                            </Select>
                          </Form.Item>
                          {!lakeDetails?.is_same_price && (
                            <Form.Item
                              {...field}
                              label={
                                +fishery_id === 12060
                                  ? 'Predator Ticket'
                                  : fishery_id === tregonethaLake
                                    ? 'Junior Ticket'
                                    : fishery_id === hawkhurst_id
                                      ? 'Concession Ticket (Junior)**'
                                      : 'Concession Ticket (Child or Senior)**'
                              }
                              name={[field.name, 'concession']}
                              Key='concession'
                              labelCol={{
                                sm: 18,
                                md: 14,
                                lg: 20,
                                xl: 18,
                                offset: 1,
                              }}
                              wrapperCol={{ sm: 4, md: 8, lg: 2, xl: 4 }}
                              valuePropName='checked'
                              className=' gSemiBold sb-light-black txt-left'
                            >
                              <Checkbox className='mg-left-10' />
                            </Form.Item>
                          )}
                        </>
                      )}
                    </Col>
                  </Col>
                ))}
              </>
            )}
          </Form.List>
          {/*  */}
        </Row>
        <Row>
          <Col className='mg-top-20'>
            {!lakeExclusive &&
              fishery_id !== exotic_fishery &&
              +fishery_id !== 12060 &&
              !lakeDetails?.is_same_price && (
                <p className='gSemiBold fs-16'>
                  Note**: Concession tickets will be checked upon arrival.
                  Please check fishery rules if you are unsure if you qualify
                  for concession.
                </p>
              )}
          </Col>
          {cartItems?.length > 0 && <ProductAddOn />}
          {customPropertyDetails?.length > 0 && (
            <div className='mg-bottom-10 w-full'>
              <div
                span={24}
                className='booking-session-heading w-full row-center mg-bottom-20'
                style={{ minHeight: 47 }}
              >
                <img
                  src={infoIcon}
                  alt='info icon'
                  style={{
                    width: '16px',
                    'vertical-align': 'sub',
                  }}
                />
                <span className='white fs-16 pd-left-10 pd-2'>
                  Additional Booking Information (Required)*
                </span>
              </div>

              {customPropertyDetails?.map((item, i) => {
                return (
                  <div className='fs-13 mg-bottom-10 gap-05r row-center flex-wrap '>
                    <div
                      className='gBold'
                      style={{ minWidth: 280, overflowWrap: 'break-word' }}
                    >
                      {item?.field_name}:
                    </div>
                    <div className='row-center gMedium' style={{ width: 280 }}>
                      <div className='w-full '>
                        {item?.field_type === 'Dropdown' ||
                        item?.field_name === 'Country' ? (
                          <Select
                            value={item?.field_value}
                            onChange={(v) => {
                              const updatedDetails = [...customPropertyDetails];
                              updatedDetails[i] = {
                                ...updatedDetails[i],
                                field_value: v,
                              };
                              setCustomPropertyDetails(updatedDetails);
                            }}
                            className=' gMedium fs-16 w-full'
                            popupClassName={
                              'admin-manage-booking-steps-select-list'
                            }
                          >
                            {item?.field_name === 'Country'
                              ? countryOptions?.map((item) => {
                                  return (
                                    <Select.Option value={item?.value}>
                                      {item?.label}
                                    </Select.Option>
                                  );
                                })
                              : item?.field_options?.map((id) => {
                                  return (
                                    <Select.Option value={id}>
                                      {id}
                                    </Select.Option>
                                  );
                                })}
                          </Select>
                        ) : item?.field_type === 'text' ||
                          item?.field_type === 'number' ? (
                          <Input
                            type={item?.field_type}
                            value={item?.field_value}
                            className='br5 fs-16'
                            onChange={(e) => {
                              const updatedDetails = [...customPropertyDetails];
                              updatedDetails[i] = {
                                ...updatedDetails[i],
                                field_value: e.target.value,
                              };

                              setCustomPropertyDetails(updatedDetails);
                            }}
                          />
                        ) : item?.field_type === 'note' ? (
                          <Input.TextArea
                            value={item?.field_value}
                            onChange={(e) => {
                              const updatedDetails = [...customPropertyDetails];
                              updatedDetails[i] = {
                                ...updatedDetails[i],
                                field_value: e.target.value,
                              };
                              setCustomPropertyDetails(updatedDetails);
                            }}
                            className='fs-16'
                          />
                        ) : item?.field_type === 'date' ? (
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              label='Select Date'
                              style={{ fontFamily: 'gRegular' }}
                              value={
                                (item?.field_value &&
                                  dayjs(item?.field_value)) ||
                                null
                              }
                              onChange={(value) => {
                                const updatedDetails = [
                                  ...customPropertyDetails,
                                ];
                                updatedDetails[i] = {
                                  ...updatedDetails[i],
                                  field_value:
                                    dayjs(value).format('YYYY-MM-DD'),
                                };
                                setCustomPropertyDetails(updatedDetails);
                              }}
                              slotProps={{
                                textField: {
                                  size: 'small',
                                  InputLabelProps: { shrink: false }, // Prevent the label from taking up space
                                  sx: {
                                    '.MuiInputLabel-root': {
                                      display: 'none', // Hide label
                                    },

                                    float: 'right',
                                    height: '32px', // Set desired height
                                    '.MuiInputBase-root': {
                                      fontFamily: 'gMedium',
                                      marginTop: 0, // Remove top margin
                                      height: '32px', // Adjust height of the input
                                    },
                                  },
                                },
                              }}
                              className='br5 fs-16 bg-white gRegular w-full  '
                              id='gRegular'
                              format='DD/MM/YYYY'
                            ></DatePicker>
                          </LocalizationProvider>
                        ) : (
                          ''
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
          {!accommodation && (
            <Col
              span={24}
              className='lake-info-content-markdown-editor mg-bottom-10'
            >
              <Col
                span={24}
                className='h-30 user-angler-info-heading mg-bottom-0 h-fit'
              >
                <p className='white gSemiBold fs-16 pd-left-10 pd-2 mg-bottom-0'>
                  {userSelectedLakeId === alderLakeId
                    ? "Enter the FULL NAMES of all anglers in the party + Lead Angler's Full Address [REQUIRED]"
                    : +fishery_id === 12060
                      ? 'Non Angling Guests Details'
                      : +fishery_id === comptonsLake
                        ? 'Please add Lead Angler’s Address + total number and full names of people in your party'
                        : lakeExclusive || fishery_id == lane_fishery_id
                          ? "Enter Estimated Number of Anglers and Lead Angler's Full Address [Required]"
                          : 'Notes'}
                </p>
              </Col>
              <Form.Item
                rules={[
                  {
                    required: lakeExclusive,
                    message:
                      +fishery_id === comptonsLake
                        ? 'Please add Lead Angler’s Address + total number and full names of people in your party'
                        : fishery_id == lane_fishery_id
                          ? 'Please enter your address'
                          : 'Please enter number of expected anglers',
                  },
                ]}
                key={`notes`}
                name='notes'
                className='gSemiBold mg-bottom-0'
              >
                <Input.TextArea
                  style={{ fontSize: 16 }}
                  placeholder={
                    userSelectedLakeId === alderLakeId
                      ? "Enter the names of all anglers in your party and the lead angler's address (the angler making this booking)"
                      : +fishery_id === 12060
                        ? 'If bringing Non Angling Guests, FULL NAMES must be entered here for insurance purposes.'
                        : +fishery_id === comptonsLake
                          ? 'Max. 3 including all anglers / non-angling guests'
                          : lakeExclusive
                            ? 'Enter the number of expected anglers in your party (if this changes before the booking date, you can inform the fishery after booking)'
                            : ''
                  }
                  className=''
                  key={`note`}
                  rows={5}
                />
              </Form.Item>
            </Col>
          )}
          {fisheryInfo?.capture_vehicle_registration && (
            <Col
              span={24}
              className='lake-info-content-markdown-editor mg-bottom-10'
            >
              <Col
                span={24}
                className='h-30 user-angler-info-heading mg-bottom-0 h-fit'
              >
                <p className='white gSemiBold fs-16 pd-left-10 pd-2 mg-bottom-0'>
                  Please enter your vehicle registration plate. *
                </p>
              </Col>
              <Form.Item
                rules={[
                  {
                    required: true,
                    message: 'Please enter vehicle registration number',
                  },
                ]}
                key={`vehicle_registration_number`}
                name='vehicle_registration_number'
                className='gSemiBold mg-bottom-0 '
                style={{ display: 'flex', marginTop: '16px' }}
              >
                <div className='row-center gap-05r flex-wrap'>
                  <div style={{ display: 'flex' }} className=''>
                    <div
                      style={{
                        height: '40px',
                        width: '40px',
                        borderRadius: '5px 0 0 5px',
                        border: 'none',
                        background: '#222F68',
                      }}
                    />
                    <input
                      value={registerationNumber}
                      onChange={(e) => {
                        if (e.target.value.length < 13) {
                          setRegistrationNumber(e.target.value.toUpperCase());
                        }
                      }}
                      type='text'
                      style={{
                        borderRadius: '0 5px 5px 0',
                        border: 'none',
                        padding: '0 16px',
                        background: '#FBC239',
                        width: '190px',
                        fontSize: '20px',
                      }}
                    />
                  </div>
                  <div style={{ color: '#B5B5B5' }} className='gMedium  fs-16'>
                    e.g XXXX-XXX{' '}
                  </div>
                </div>
              </Form.Item>
            </Col>
          )}
        </Row>
        {lakeExclusive && (
          <div style={{ marginTop: '20px' }}>
            <div className='booking-session-heading h-40'>
              <span className='white   fs-16 pd-left-10 pd-2'>
                {DynamicText?.is_active &&
                DynamicText?.properties?.booking_step_3?.lake_exclusive_header
                  ? DynamicText?.properties?.booking_step_3
                      ?.lake_exclusive_header
                  : `${accommodation ? 'Booking ' : 'Lake Exclusive '}
                Information: (PLEASE READ)`}
              </span>
            </div>

            <div className='py-10 mg-bottom-50'>
              <div className='mg-bottom-10'>
                <Row justify={'space-between'} className='gBold fs-18'>
                  <Col>Amount To Pay Today:</Col>
                  <Col> {costString(estimatedDeposit)}</Col>
                </Row>
              </div>
              {estimatedBalance > 0 && (
                <Col className='mg-bottom-10'>
                  <Row justify={'space-between'} className='gBold fs-18'>
                    <Col>Balance Owed:</Col>
                    <Col> {costString(estimatedBalance)}</Col>
                  </Row>
                  <span className='gLight'>
                    You will be sent a reminder email when the balance is due.{' '}
                  </span>
                </Col>
              )}
              <Col className='mg-bottom-10'>
                <Row justify={'space-between'} className='gBold fs-18'>
                  <Col>Total Price:</Col>
                  <Col
                    className={isEstimateDiscounted ? 'txt-strikethrough' : ''}
                  >
                    {' '}
                    {costString(estimatedTotal)}
                  </Col>
                </Row>
                {isEstimateDiscounted && (
                  <Row justify={'space-between'} className='gBold fs-18'>
                    <Col className='sb-blue-bg br5 fs-16 gSemiBold txt-center white pd-2 pd-left-15 pd-right-15 mg-top-4 mg-bottom-4'>
                      Promotion Applied:
                    </Col>
                    <Col>{costString(estimatedDiscountedTotal)}</Col>
                  </Row>
                )}
                {!accommodation && (
                  <p className='gBold fs-18 mg-bottom-0'>
                    {DynamicText?.is_active
                      ? DynamicText?.properties?.booking_step_3
                          ?.header_anglers_info
                      : `(Lake Exclusive for up to ${
                          lakeDetails?.lake_exclusive_anglers_allowed
                            ? lakeDetails.lake_exclusive_anglers_allowed
                            : 'X'
                        } anglers)`}
                  </p>
                )}
                {lakeDetails?.lake_exclusive_balance_due_reminder > 0 &&
                  estimatedBalance > 0 && (
                    <span className='gLight'>
                      Due{' '}
                      <span className='sb-blue'>
                        {lakeDetails?.lake_exclusive_balance_due_reminder
                          ? lakeDetails.lake_exclusive_balance_due_reminder
                          : '28'}
                      </span>{' '}
                      days before booking commencement date.{' '}
                    </span>
                  )}
              </Col>
              {userSelectedPakage && (
                <Row className='gBold fs-16'>
                  <Col>Package Selected:</Col>
                  <Col className='gMedium mg-left-10'>
                    {
                      lakeDetails?.custom_slot_days[userSelectedPakage - 1]
                        ?.name
                    }
                  </Col>
                </Row>
              )}
            </div>
          </div>
        )}
        <Row style={{ marginTop: '20px' }}>
          <div>
            <p className='terms-title mg-bottom-5 gSemiBold sb-light-grey'>
              Accept terms and proceed to checkout:
            </p>
          </div>
        </Row>
        <Divider className='terms-divider' />
        {!accommodation && (
          <Form.Item
            name='agreement'
            valuePropName='checked'
            rules={[
              {
                validator: (_, value) =>
                  value
                    ? Promise.resolve()
                    : Promise.reject('Should accept agreement'),
              },
            ]}
          >
            <Checkbox className='gLight fs-16 lg-checkbox'>
              {fishery_id === exotic_fishery && !is_exotic_arapaima_lake
                ? 'By completing this booking, you understand that you are paying a 50% deposit and the balance will be due 4 weeks prior to booking date.'
                : +fishery_id === comptonsLake
                  ? termsText
                  : is_exotic_arapaima_lake
                    ? 'By completing this booking you understand that payment is non-refundable.'
                    : `By completing this booking, you agree that all anglers hold valid fishing licenses and agree to comply with the ${
                        DynamicText?.is_active &&
                        DynamicText?.properties?.booking_step_3
                          ?.compliance_fishery_mention
                          ? DynamicText?.properties?.booking_step_3
                              ?.compliance_fishery_mention
                          : 'fishery'
                      } rules.`}
            </Checkbox>
          </Form.Item>
        )}
        <Form.Item
          name='agreement2'
          valuePropName='checked'
          rules={[
            {
              validator: (_, value) =>
                value
                  ? Promise.resolve()
                  : Promise.reject('Should accept agreement'),
            },
          ]}
        >
          <Checkbox className='gLight fs-16 lg-checkbox'>
            By placing your booking, you confirm and accept swimbooker's{' '}
            <a
              href={TERMS_AND_CONDITIONS_URL}
              target='_blank'
              rel='noopener noreferrer'
              className='gSemiBold'
            >
              terms
            </a>{' '}
            and{' '}
            <a
              href={PRIVACY_POLICY_URL}
              target='_blank'
              rel='noopener noreferrer'
              className='gSemiBold'
            >
              privacy policy
            </a>
            .
          </Checkbox>
        </Form.Item>

        <Form.Item>
          <UserBookingNavButtons
            onPrev={() => {
              if (
                lakeType.toLowerCase() === 'ticket' ||
                bookingType === 'ticket' ||
                lakeExclusive
              ) {
                setCurrent(current - 2);
              } else {
                setCurrent(current - 1);
              }
            }}
            nextProps={{
              className: disableNext ? 'disabled' : 'enabled',
              htmlType: isFormValid ? 'submit' : '',
            }}
            nextText='Proceed to Summary'
            nextColourClass='light-green-bg'
            pageKey='anglers'
          />
        </Form.Item>
      </Form>
    </div>
  );
}
